export default __webpack_public_path__ + "static/media/2xYear.371c936a.png";